import i18n from "i18next";
import { initReactI18next } from "react-i18next";

import Backend from "i18next-http-backend";
import LanguageDetector from "i18next-browser-languagedetector";
import { config } from "./utils/config";

// Get build version for cache busting
const getVersion = () => {
  return config.version;
};

// don't want to use this?
// have a look at the Quick start guide
// for passing in lng and translations on init
const customDetector = {
  name: "customDetector",
  lookup: () => {
    const userDataString = localStorage.getItem("userData");
    const userData = userDataString ? JSON.parse(userDataString) : null;
    return userData ? userData.language : null;
  },
};

i18n
  .use(Backend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    detection: {
      order: [
        "customDetector",
        "querystring",
        "cookie",
        "localStorage",
        "navigator",
        "htmlTag",
        "path",
        "subdomain",
      ],
      caches: ["localStorage"],
      customDetectors: [customDetector],
    },
    backend: {
      // Add cache busting to translation file requests
      loadPath: `/locales/{{lng}}/translation.json?v=${getVersion()}`,
      // Parse response
      parse: function(data) {
        return JSON.parse(data);
      }
    },
    fallbackLng: "de",
    debug: true,
    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;
